import React, { useEffect } from 'react'
import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
// import Submiteditperson from '../Submiteditperson'
// import require from 'axios'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import CreatePerson from '../CreatePerson'
import CreatePersonService from '../../../Services/Mutations/CreatePersonService'
import AwsConfig from '../../../Config/AwsConfig'
import axios from 'axios'
import MovieImagePresignedUrl from '../../../Services/Queries/Movieimagepresignedurl'
// import CreatePersonService from '../../../Services/Mutations/CreatePersonService'
function MultiplePersons() {
  const [getInputDataFromCreatePerson, setgetInputDataFromCreatePerson] = useState([])
  const [missingPersonsList, setMissingPersonsList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [personIndexSelectionObj, setPersonIndexSelectionObj] = useState({})
  const [MultiplePersonsArray, setMultiplePersonsArray] = useState([])
  const [personDisableCheckBoxObj, setPersonDisableCheckBoxObj] = useState({})
  // const [MultiplePersonspresent, setMultiplePersonspresent] = useState({})
  // const personRef = useRef()
  // const UpdateinMultiplePersons = (personindex, data) => {
  //   const MultiplePersonspresent = { ...MultiplePersonspresent }
  //   MultiplePersonspresent[personindex] = data
  //   setMultiplePersonspresent(MultiplePersonspresent)
  // }

  const { ScrapeUrlV2 } = AwsConfig
  const createMultiplePersons = async () => {
    const MultiplePersonsArrayTemp = MultiplePersonsArray.filter(e => e.personSelected === true)
    MultiplePersonsArrayTemp.map(e => delete e.personIndex)
    MultiplePersonsArrayTemp.map(async e => {
      try {
        await CreatePersonService(e)
      } catch (error) {
        console.warn(error)
      }
    })
  }

  // function for updating multiple person inputs
  const sendInputCreatePerson = data => {
    const MultiplePersonsArrayTemp = [...MultiplePersonsArray]

    // if personIndex value of data is not present in MultiplePersonsArrayTemp then add it
    if (MultiplePersonsArrayTemp.findIndex(e => e.personIndex === data.personIndex) === -1) {
      MultiplePersonsArrayTemp.push(data)
    } else {
      // if personIndex value of data is present in MultiplePersonsArrayTemp then update it
      const index = MultiplePersonsArrayTemp.findIndex(e => e.personIndex === data.personIndex)
      MultiplePersonsArrayTemp[index] = data
    }

    setgetInputDataFromCreatePerson([])
    // MultiplePersonsArrayTemp.push(...data)
    setMultiplePersonsArray(MultiplePersonsArrayTemp)
  }

  const DisableCheckBox = (personindex, data) => {
    const personDisableCheckBoxObjtemp = { ...personDisableCheckBoxObj }
    personDisableCheckBoxObjtemp[personindex] = data
    setPersonDisableCheckBoxObj(personDisableCheckBoxObjtemp)
  }

  const MultiplePersonsChecked = (personindex, data) => {
    const personIndexSelectionObjtemp = { ...personIndexSelectionObj }
    personIndexSelectionObjtemp[personindex] = data
    // console.log(personIndexSelectionObjtemp, 'personIndexSelectionObjtemp')
    setPersonIndexSelectionObj(personIndexSelectionObjtemp)

    if (data === false) {
      // personIndexSelectionObjtemp[personindex] = data
      // find index of personindex in MultiplePersonsArray
      const index = MultiplePersonsArray.findIndex(e => e.personIndex === personindex)
      // remove that index from MultiplePersonsArray
      const MultiplePersonsArrayTemp = [...MultiplePersonsArray]
      MultiplePersonsArrayTemp.splice(index, 1)
      setMultiplePersonsArray(MultiplePersonsArrayTemp)
    }
  }

  const dateOfBirth = editvalue => {
    const tempValue = editvalue.split('-')
    const tempeoryValue = tempValue[0] + tempValue[1] + tempValue[2]

    return tempeoryValue ? tempeoryValue : ''
  }

  const createPersonsDiabled = () => {
    const MultiplePersonsArrayTemp = MultiplePersonsArray.filter(e => e.personSelected === true)

    if (MultiplePersonsArrayTemp.length === 0) {
      return false
    }

    return MultiplePersonsArrayTemp?.every(
      e =>
        e.name_En &&
        e.name_Te &&
        e.posterURL &&
        e.about_En &&
        e.about_Te &&
        e.personWikiURL,
    )
  }

  function convertBlobToFile(blob, fileName) {
    blob.lastModifiedDate = new Date()
    blob.name = fileName
    return blob
  }

  async function getImageFromURL(imageUrl) {
    const response = await fetch(imageUrl, {
      method: 'GET',
      headers: {},
    })

    const arrayBuffer = await response.arrayBuffer()

    const blob = new Blob([arrayBuffer, { type: 'image/png' }])

    const file = convertBlobToFile(blob, 'image.png')

    return file
  }

  // const disableCheckbox = () => {
  //   personRef.current.DisableCheckBox()
  // }

  const uploadSelectedImage = async data => {
    const randomId = await uuidv4()
    const moviePath = AwsConfig.moviePathUrl
    const key = moviePath + randomId + '.jpeg'
    const params = {
      key,
      mimeType: 'image/jpeg',
    }
    const preSignedURLObject = await MovieImagePresignedUrl(params)
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
    const signedURL = signedURLObject.data.url

    const formData = new FormData()

    Object.keys(signedURLObject.data.fields).forEach(key => {
      formData.append(key, signedURLObject.data.fields[key])
    })
    // Actual file has to be appended last.
    formData.append('file', data)

    await axios({
      method: 'post',
      url: signedURL,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    const cdnurl = AwsConfig.movieCdnUrl
    const posterUrl = cdnurl + key

    return posterUrl
  }

  useEffect(() => {
    setIsLoading(true)

    const getMovieDataFromUrl = async () => {
      const url = window.location.href
      const urlsplit = url.split('?')
      const dataTemp = decodeURIComponent(urlsplit[1] ? urlsplit[1] : '')
      let dataUrls = dataTemp?.split('===,')
      dataUrls = dataUrls.map(e => e.replace('===', ''))

      const raw = JSON.stringify({
        contentType: 'person',
        allURLs: dataUrls,
      })
      const requestOptions = {
        method: 'POST',
        body: raw,
        redirect: 'follow',
      }
      fetch(ScrapeUrlV2, requestOptions)
        .then(response => response.text())
        .then(result => {
          const responseData = result.split('======')
          responseData.forEach((e, index) => {
            if (e.includes('unable') || e.includes('Unable')) {
              // delete responseData[index]
              responseData.splice(index, 1)
            }
          })

          // remove last value from array

          // check for unable to scrape  person with this url
          const splitedData = responseData.map(item => item.split(/"/g))
          const filteredData = splitedData.map(item => item.filter(item => item !== ','))

          // const res = b.map(info => info.map(item => JSON.parse(item)))

          const data = filteredData.slice(0, filteredData.length - 1)

          const headers = data[0].filter(item => item !== '')

          // all values from  dataarray except first one
          const values = data.slice(1)

          const valuesList = values.map(item => {
            item.shift()
            item.pop()
            return item
          })

          const totalFilteredArray = valuesList.map(item =>
            item.map(item => {
              item.replaceAll(/'/g, '')
              // item.replace(/['‘’"“”]/g, '')

              return item
            }),
          )

          const finalData = totalFilteredArray.map(item => {
            const eachObj = {}

            headers.forEach((header, index) => {
              eachObj[header] = item[index].replace(/['‘’"“”]/g, '')
            })
            return eachObj
          })
          // setdata(finalData)

          const datat123 = [...finalData]
          // const missigPersonsWithImage = []
          datat123.forEach(async (e, index) => {
            const file = await getImageFromURL(e.posterURL)
            // const
            datat123[index].posterURL = await uploadSelectedImage(file)
            datat123[index].dateOfBirth = await dateOfBirth(e.dateOfBirth)
            // missigPersonsWithImage.push({
            //   ...e,
            //   posterURL: posterImage,
            // })
          })

          setTimeout(() => {
            setMissingPersonsList(datat123)
            setIsLoading(false)
          }, 2000)
        })
        .catch(error => {
          console.warn(error)
        })
      // */
    }

    getMovieDataFromUrl()
  }, [])

  return (
    <div>
      <lable className='m-1'>
        <b>All Missing Persons</b>
      </lable>
      {missingPersonsList &&
        missingPersonsList.map((item, index) => (
          <Accordion allowZeroExpanded key={index}>
            <AccordionItem key={item.uuid}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  personName: {item.name_En}
                  {personIndexSelectionObj[`person${index + 1}`] ? (
                    <div style={{ color: 'green' }}>Person selected</div>
                  ) : (
                    <></>
                  )}
                  {/* <input
                    type='checkbox'
                    id={`person${index + 1}`}
                    checked={personIndexSelectionObj[`person${index + 1}`]}
                    disabled={!personDisableCheckBoxObj[`person${index + 1}`]}
                    value=''
                    onChange={e => {
                      MultiplePersonsChecked(e.target.id, e.target.checked)
                    }}
                  /> */}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <CreatePerson
                  // ref={personRef}
                  MultiplePersons={true}
                  // MultiplePersonspresent={MultiplePersonspresent}
                  DisableCheckBoxParent={DisableCheckBox}
                  // UpdateinMultiplePersons={UpdateinMultiplePersons}
                  sendInputCreatePerson={sendInputCreatePerson}
                  personIndex={`person${index + 1}`}
                  MultiplePersonsArray={MultiplePersonsArray}
                  MultiplePersonsChecked={MultiplePersonsChecked}
                  personIndexSelectionObj={personIndexSelectionObj}
                  getInputDataFromCreatePerson={getInputDataFromCreatePerson}
                  personData={item}
                  missingPersonsList={missingPersonsList}
                  style={{ width: '100%' }}
                />
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        ))}
      {isLoading ? (
        <div className='loading-overlay'>
          <span className='fas fa-spinner fa-3x fa-spin'></span>
        </div>
      ) : (
        ''
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <button
          className='btn btn-primary m-2'
          onClick={createMultiplePersons}
          disabled={!createPersonsDiabled()}
        >
          Create Persons
        </button>
      </div>
    </div>
  )
}

export default MultiplePersons
